import React from "react";
import Icon from "components/AppIcon";

const TemplateNeoCoinsBar = ({ neoCoins }) => {
  const neoCoinsLabel =
    neoCoins == null || neoCoins === ""
      ? "…"
      : typeof neoCoins === "number" && Number.isFinite(neoCoins)
        ? String(Math.trunc(neoCoins))
        : String(neoCoins);

  return (
    <div
      className="inline-flex w-full min-w-0 shrink-0 items-center justify-center gap-2 rounded-md border border-border bg-muted/40 px-3 py-2 text-sm shadow-sm pointer-events-none select-none sm:w-auto sm:justify-start"
      role="status"
      aria-label={`Neo Coins ${neoCoinsLabel}`}
      title={`Neo Coins: ${neoCoinsLabel}`}
    >
      <Icon name="Coins" size={18} className="text-amber-500 shrink-0" aria-hidden />
      <span className="font-medium text-muted-foreground">Neo Coins</span>
      <span className="font-semibold tabular-nums text-foreground">{neoCoinsLabel}</span>
    </div>
  );
};

export default TemplateNeoCoinsBar;
